import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Container } from '@mui/material';
import classNames from 'classnames';
import theme from '../../styles/theme';
import variables from '../../styles/variables';

import styles from './site-components/site.module.css';

const useStyles = makeStyles(() => ({
  root: {},
  benefit: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      margin: '60px 0 60px 0',
    },

    '& .left': {
      margin: '0 90px 0 0 ',
      flexBasis: '50%',
    },
    '& .right': {
      flexBasis: '50%',
    },

    '& .leftImg': {
      margin: '0 90px 0 0 ',

      [theme.breakpoints.down('md')]: {
        margin: '0px 0 0px 0',
      },

      flexBasis: '50%',
    },
    '& .rightImg': {
      flexBasis: '50%',
    },

    '& img': {
      height: 'auto',
      width: '100%',

      [theme.breakpoints.down('md')]: {
        margin: '30px 0 30px 0',
      },
    },

    '& .miniHeading': {
      textTransform: 'uppercase',
      padding: '0 0 10px 0',
      fontSize: '14px',
    },
    '& .heading': {
      fontSize: '36px',
      fontWeight: '700',
    },
    '& .desc': {
      margin: '10px 0 0px 0',
      fontSize: '20px',
      lineHeight: '30px',
      fontWeight: '400',
    },
    '& .link': {
      fontSize: '18px',
      fontWeight: '600',
      margin: '10px 0 0 0',

      '& a': {
        color: variables.composerBlack,
      },
    },
  },
}));

const Api = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="xl" className={classNames(styles.container, styles.section)}>
        <Box className={styles.header}>Integrate Transmit within your 1st or 3rd party video streaming platform.</Box>
        <Box className={styles.description}>Get the flexibility and control of your manifest manipulation process.</Box>
        <Box className={styles.mt6}>
          <img
            className={styles.maxWidthImg}
            src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/api-diagram@2x.png"
            alt="howItWorks"
          />
        </Box>
        <Box className={classNames(classes.benefit, styles.flex, styles.mt12)}>
          <Box className="left">
            <Box className="miniHeading">Pod Serving</Box>
            <Box className="heading">Own your manifest</Box>
            <Box className="desc">
              Give us your content and creative. Well encode your assets in the format you designed in the Creative
              Studio and give you back the encoded segments ready to stitch into your manifest.
            </Box>
          </Box>
          <Box className="rightImg">
            <img src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/stitch@2x.png" alt="hyundaiPiP" />
          </Box>
        </Box>
        <Box className={classes.benefit}>
          <Box className="leftImg">
            <img src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/market@2x.png" alt="hyundaiPiP" />
          </Box>
          <Box className="right">
            <Box className="miniHeading">Transmit Marketplace</Box>
            <Box className="heading">Let us help</Box>
            <Box className="desc">
              Need help filling your inventory. Just give us your content and leverage the Transmit Marketplace. Well
              fill the demand and give you back the rest.
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default Api;
